import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import useSetorFetch from "./useSetorFetch";
import { Setor } from "../../types/setor/Setor";


type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: Setor ;
    handleSearchChange: (newValue: Setor) => void;
};


const TxtSetor = ({
    isdisabled,
    isLoading,

    required = false,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useSetorFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete
            value={value && value.id ? value : null} // 
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option) => {
                const setor = option as Setor;
                let descricao: string = "";

                if (!setor) {
                    return '';
                }

               
                if (setor.secretaria?.orgao?.abreviatura) {
                    descricao += setor.secretaria.orgao.abreviatura;
                }

                if (setor.secretaria?.abreviatura) {
                    descricao += " - " + setor.secretaria.abreviatura;
                }
                if (setor.nome) {
                    descricao += " - " +  setor.nome;
                }



                return descricao;
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as Setor);
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Unidade / Setor / Dpto"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtSetor;

